import { useEffect, useRef, useState } from 'react';
import DashboardLayout from 'components/app/DashboardLayout'
import axios from 'utils/axios'
import 'react-loading-skeleton/dist/skeleton.css'
import Button from "components/form/Button"
import {
  FirstName,
  LastName,
  Gender,
  Nationality,
  Notes,
  DateOfBirth,
  DateOfDeath
} from 'components/form/FormComposer'
import ErrorMessage from "components/form/ErrorMessage"
import SuccessMessage from "components/form/SuccessMessage"
// import useSWR from 'swr'
import classNames from 'classnames'
import Loader from "components/ui/Loader"
import {
  MultipleLinkInput,
} from 'components/form/FormOeuvre';
import {
  genders,
  country
} from "constants/data-filter";
import { API_ENDPOINTS } from 'utils/api-endpoints';

const ItemTab = ({ item }) => {

  return (
    <tr className="border-b bg-white">
      <td className="py-4 px-6 text-sm">
        {item.firstName}
      </td>
      <td className="py-4 px-6 text-sm">
        {item.lastName}
      </td>
      <td className="py-4 px-6 text-sm">
        {item.dateOfBirth}
      </td>
      <td className="py-4 px-6 text-sm">
        {item.nationality_id[0]}...
      </td>
      <td className="py-4 px-6 text-sm">
        {item.gender}
      </td>
      <td className="flex justify-start py-3 pr-6">

        {item.status.toLowerCase() === "pending" && <span className="text-xs px-2 py-1 font-semibold leading-tight text-yellow-700 bg-yellow-100 rounded-full capitalize">{item.status}</span>}
        {item.status.toLowerCase() === "accepted" && <span className="text-xs px-2 py-1 font-semibold leading-tight text-green-700 bg-green-100 rounded-full capitalize">{item.status}</span>}
        {item.status.toLowerCase() === "refused" && <span className="text-xs px-2 py-1 font-semibold leading-tight text-pink-700 bg-pink-100 rounded-full capitalize">{item.status}</span>}

      </td>
    </tr>
  )
}

const displayComposerForUser = (data) => {
  return (
    <>
      {data.map((item) => (
        <ItemTab item={item} />
      ))}
    </>
  )
}

function Composer() {

  const selectGender = useRef(null);
  const selectNation = useRef(null);

  // User infos
  const [created, setCreated] = useState(true),
    [composers, setComposers] = useState([]),
    // [allCountrie, setAllCountrie] = useState([]),
    [dataComposer, setDataComposer] = useState(
      {
        lastName: '',
        firstName: '',
        dateOfBirth: '',
        dateOfDeath: '',
        gender: '',
        webSiteLink: [],
        notes: '',
        nationality: []
      });

  const [fieldHelp, setFieldHelp] = useState("");

  // handling state
  const [isLoading, setIsLoading] = useState(false),
    [errors, setErrorsMessage] = useState([]),
    [success, setSuccessMessage] = useState(null),
    [isSubmitted, setIsSubmitted] = useState(false);

  // Get composers submitted by user
  const getUserComposer = async () => {
    await axios.get(API_ENDPOINTS.GET_COMPOSER).then(res => {
      const { data } = res.data;
      setComposers(data);
    }).catch((err) => {
      console.log("error", err.response)
    })
  }

  useEffect(() => {
    getUserComposer();
  }, []);

  const handleNationality = (e) => {
    let dataNat = e;
    let newData = [];

    dataNat.forEach((res) => (
      newData.push(res.countries)
    ))
    setDataComposer({ ...dataComposer, nationality: newData })
  }

  // Submit cmposers form
  const submitFormComposer = () => {

    setIsSubmitted(true);

    setErrorsMessage([]);

    setSuccessMessage(null);

    setIsLoading(true);

    axios.post(API_ENDPOINTS.ADD_COMPOSER, dataComposer).then(res => {
      if (res.status === 200) {
        setIsSubmitted(false);
        setIsLoading(false);
        setSuccessMessage("Created successfuly !")
        setDataComposer(
          {
            lastName: '',
            firstName: '',
            dateOfBirth: '',
            dateOfDeath: '',
            webSiteLink: [],
            notes: ''
          }
        );
        selectNation?.current.clearValue();
        selectGender?.current.clearValue();

        setTimeout(() => {
          setCreated(true);
          getUserComposer();
          setSuccessMessage(null);
        }, 1000)
      }
    }).catch((error) => {
      console.log("error", error);
      setErrorsMessage(Object.values(error.response.data.errors).flat())
      setIsLoading(false);
    })
  }

  const addNewWebSiteLink = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      if(dataComposer.webSiteLink == null){
        setDataComposer({...dataComposer, webSiteLink:[]});
      }
      setDataComposer({...dataComposer, webSiteLink:[...dataComposer.webSiteLink, event.target.value]});
        event.target.value = "";
    }
  };

  return (
    <DashboardLayout>
      <div className="mb-4 flex flex-col md:flex-row items-start md:items-center justify-between">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 z-20">
            {!created ? 'Add a new composer' : 'Composers submitted'}
          </h2>
        </div>
        <div className="flex">
          <Button
            onClick={() => setCreated(!created)}
          >
            {!created ? 'See all composers' : 'Add a new composer'}
          </Button>
        </div>
      </div>
      <div className="w-full flex flex-col">

        <div className={`${created ? ' hidden ' : ' block '}${" w-full bg-white shadow-xl mb-24 w-full space-y-4 p-8 "}`}>

          <i className="block flex flex-col items-start text-xs text-red-500"> The fields with * are required </i>

          <LastName
            value={dataComposer.lastName}
            onChange={(e) => setDataComposer({ ...dataComposer, lastName: e.target.value })}
            isSubmitted={isSubmitted}
            isRequired={true}
          />

          <FirstName
            value={dataComposer.firstName}
            onChange={(e) => setDataComposer({ ...dataComposer, firstName: e.target.value })}
            isSubmitted={isSubmitted}
            isRequired={true}
          />

          <DateOfBirth
            value={dataComposer.dateOfBirth}
            onChange={(e) => setDataComposer({ ...dataComposer, dateOfBirth: e.target.value })}
            isSubmitted={isSubmitted}
            isRequired={true}
          />

          <DateOfDeath
            value={dataComposer.dateOfDeath}
            onChange={(e) => setDataComposer({ ...dataComposer, dateOfDeath: e.target.value })}
            isSubmitted={isSubmitted}
          />

          <Gender
            value={dataComposer.gender}
            options={genders}
            myRef={selectGender}
            onChange={(e) => setDataComposer({ ...dataComposer, gender: e?.value })}
            isSubmitted={isSubmitted}
          />

          <MultipleLinkInput
            fieldName={"WebSite Link"}
            onKeyUp={event => event.key === "Enter" ? addNewWebSiteLink(event) : null}
            onClick={() => setFieldHelp('WebSite')}
            help={fieldHelp === "WebSite" ? true : false}
            showHelp={true}
            showAlert={true}
            textHelp="Copy here a url referring to the official website of the composer, to a website dedicated to this composer or to the wikipedia page dedicated to the composer"
            isSubmitted={isSubmitted}
          >
            {dataComposer?.webSiteLink?.map((item, index) => (
              <li key={index} className="tag">
                <span className='tag-title'>{item}</span>
                <span className='tag-close-icon'
                  onClick={() => setDataComposer({
                    ...dataComposer,
                    webSiteLink: [...dataComposer.webSiteLink.filter(link => dataComposer.webSiteLink.indexOf(link) !== index)]
                  })
                  }
                >x</span>
              </li>
            ))}
          </MultipleLinkInput>

          <Nationality
            value={dataComposer.nationality}
            myRef={selectNation}
            options={country}
            onChange={(e) => handleNationality(e)}
            isSubmitted={isSubmitted}
            isRequired={true}
          />

          <LastName
            fieldName="Custum country (You can enter a country if isn't found on this list)"
            value={dataComposer.nationality}
            onChange={(e) => setDataComposer({ ...dataComposer, nationality: e.target.value })}
            isSubmitted={isSubmitted}
            isRequired={false}
          />
          
          <Notes
            value={dataComposer.notes}
            onChange={(e) => setDataComposer({ ...dataComposer, notes: e.target.value })}
            isSubmitted={isSubmitted}
          />

          <ErrorMessage errors={errors} />
          <SuccessMessage success={success} handleHideMsg={() => setSuccessMessage('')} />

          {/* Action */}
          <div className="flex flex-col py-4 items-end">

            <Button
              disabled={isLoading}
              onClick={() => submitFormComposer()}
              className={classNames(
                !isLoading ? '' : 'bg-gray-500 opacity-50 cursor-not-allowed',
                ""
              )}
            >
              {!isLoading ? 'Create' :
                <> <Loader /> <span className="mr-1"></span> Creating... </>
              }
            </Button>
          </div>
        </div>

        <div className={`${!created ? ' hidden ' : ' block '}${" w-full overflow-x-auto"}`}>
          <table className="min-w-full shadow-xl">
            <thead className="bg-pblue text-pblue text-xs font-semibold text-left text-white uppercase">
              <tr>
                <th scope="col" className="py-3 px-6">
                  FirstName
                </th>
                <th scope="col" className="py-3 px-6">
                  LastName
                </th>
                <th scope="col" className="py-3 px-6">
                  Date of birth
                </th>
                <th scope="col" className="py-3 px-6">
                  Nationality
                </th>
                <th scope="col" className="py-3 px-6">
                  Gender
                </th>
                <th scope="col">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>{displayComposerForUser(composers)}</tbody>
          </table>
        </div>

      </div>
    </DashboardLayout>
  )
}

export default Composer;